/**
 * Find whether a variable is an object
 *
 * @param {mixed} variable - The variable being evaluated
 * @return  {boolean}   TRUE if the variable is an object
 */
const isObject = ( variable ) => {
	return variable !== null && typeof variable === 'object';
};

export default isObject;
